import { useEffect, useState } from 'react';

import { debounce, isWindowDefined, safeNumber } from '@framework/utils';

/**
 * Evaluates scrollbar width to calculate offset value
 * @param HTMLElement sourceElement - Preferably React ref object (myRef.current), but can be a DOM element
 * @param boolean condition - Condition boolean to gate reevaluating offset value
 * @returns Number offset
 */
const useScrollOffset = (sourceElement: HTMLElement | null, condition: boolean): number => {
    const [offset, setOffset] = useState<number>(0);
    const [windowSize, setWindowSize] = useState<number>(
        isWindowDefined() ? window.innerHeight : 0
    );

    useEffect(() => {
        const handleResize = debounce(() => {
            setWindowSize(isWindowDefined() ? window.innerHeight : 0);
        }, 1000);

        if (isWindowDefined()) {
            window.addEventListener('resize', handleResize);
        }
        return () => {
            if (isWindowDefined()) {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, []);

    useEffect(() => {
        if (condition && sourceElement) {
            setOffset(
                safeNumber(sourceElement?.offsetWidth) - safeNumber(sourceElement?.clientWidth)
            );
        }
    }, [condition, windowSize, sourceElement?.offsetWidth, sourceElement?.clientWidth]);
    return offset;
};

export default useScrollOffset;
